<template>
    <section>
        <el-tabs type="border-card" v-model="tab" @tab-click="resetBanner()">
            <el-tab-pane name="table" :label="title">
                <el-card>
                    <el-table :data="tableData"  height="600" style="width: 100%">
                        <el-table-column label="图片" align="center">
                            <template slot-scope="scope">
                                <m-img v-if="scope.row" :src="scope.row.pic_url" :width="344" :height="182" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="title"   align="center" label="名称"></el-table-column>
                        <el-table-column prop="link"    align="center" label="链接"></el-table-column>
                        <el-table-column prop="color"    align="center" label="背景色"></el-table-column>
                        <el-table-column prop="start_time_date"  align="center" label="开始时间"></el-table-column>
                        <el-table-column prop="end_time_date"  align="center" label="结束时间"></el-table-column>
                        <el-table-column prop="sort_id" align="center" label="排序">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.sort_id" @change="handleSort(scope.row)" size="mini"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="编辑" align="center">
                            <template slot-scope="scope">
                                <div class="table-btns">
                                    <el-button type="success" plain size="mini"  @click="handleGoPut(scope.row)">修改</el-button>
                                    <el-button type="danger"  plain size="mini"  @click="handleDel(scope.$index,scope.row)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
                </el-card>
            </el-tab-pane>

            <el-tab-pane name="edit" label="添加 | 修改" >
                <el-card class="m-bottom-4">
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            轮播名称：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="banner.title" placeholder="请输入名称" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            轮播链接：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="banner.link" placeholder="例：https://www.google.com" style="width:220px"></el-input>
                            <span style="color:grey;font-size:0.9em;">（*跳转搜索结果页需要在链接后面添加“?skey=关键词&b=1”）</span>
                        </el-col>
                    </el-row>
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            轮播排序：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="banner.sort_id" placeholder="请输入排序" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="m-bottom-4">
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            轮播图片：
                        </el-col>
                        <el-col :span="22" style="display:flex;">
                            <m-upload :img.sync="image"  :width="220" :height="104" file-name="Banner"  placement="right" />
                            <div class="suggest-size">
                                （*建议尺寸343×162px，JPG、PNG、GIF等格式图片）
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="2" class="input-left">
                            图片背景：
                        </el-col>
                        <el-col :span="22">
                            <el-input v-model="banner.color" placeholder="请输入背景色（选填）" style="width:220px"></el-input>
                        </el-col>
                    </el-row>
                </el-card>
                <el-card class="m-bottom-4">
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            开始时间：
                        </el-col>
                        <el-col :span="22">
                            <el-date-picker v-model="banner.start_time" value-format="timestamp"  type="datetime" placeholder="选择开始时间"></el-date-picker>
                        </el-col>
                    </el-row> 
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            结束时间：
                        </el-col>
                        <el-col :span="22">
                            <el-date-picker v-model="banner.end_time" value-format="timestamp"  type="datetime" placeholder="选择结束时间"></el-date-picker>
                        </el-col>
                    </el-row>  
       
                </el-card>
                <el-card>
                    <el-row class="m-bottom-4">
                        <el-col :span="2" class="input-left">
                            提交信息：
                        </el-col>
                        <el-col :span="22">
                            <el-button :disabled="disabled"  @click="handleBtn()" type="success" plain>确认提交</el-button>
                        </el-col>
                    </el-row>
                </el-card>
            </el-tab-pane>

            
        </el-tabs>
            
        
    </section>
</template>
<script>
import { banner_list, banner_add, banner_del, banner_put } from '@/api/market.js'
import MUpload from '@/components/m-upload.vue'
import MImg   from './../../../components/Image'
export default {
    name:'GoodsEdit',
    components:{ MUpload, MImg },
    data () {
        return {
            title: '',
            place_id  : '',

            tab: 'table',
            image: { url: '', pic_id: '' },   // 主图
            banner:{
                id        : '',
                title     : '',
                start_time: '',
                end_time  : '',
                link      : '',
                sort_id   : '',
                color     : '', 
            },

            tableData: [],
            total: 0,
            page: 1,
            size: 20,
            disabled: false,
        }
    },
    methods:{
        
        // 重置数据
        resetBanner() {
            this.image.pic_id = ''
            this.image.url    = ''
            this.banner = {
                id        : '',
                title     : '',
                start_time: '',
                end_time  : '',
                link      : '',
                sort_id   : '',
                color     : '', 
            }
        },


         // 获取详情列表
        getDetail(id) {
          let params = {
            place_id:id
          }
          banner_list(params).then(res => {
            if(res) {
              this.tableData = res.data.data
              this.total = res.data.total
              this.size = res.data.per_page
            }
            
          })
        },

        // 点击提交按钮  有id修改 无id添加  
        handleBtn() {
            if(this.banner.id == '') {
                this.handleAdd()
            }else {
                 this.handlePut()
            }
        },

        // 添加轮播图
        handleAdd() {
             if(this.banner.title == ''){
                this.$message.error("请输入名称!")
                return false;
            }
            if(this.image.pic_id == ''){
                this.$message.error("请上传图片!")
                return false;
            }
           
            if(this.banner.sort_id == ''){
                this.$message.error("请输入排序!")
                return false;
            }
            if(this.banner.link == ''){
                 this.$message.error("请输入轮播链接!")
                return false;
            }
            if(this.banner.start_time == ''){
                this.$message.error("请选择开始时间!")
                return false;
            }
            if(this.banner.end_time == ''){
                this.$message.error("请选择结束时间!")
                return false;
            }
            this.disabled = true
            let params = {
                title: this.banner.title,
                place_id: this.place_id,
                sort_id: this.banner.sort_id,
                link:this.banner.link,
                pic_id: this.image.pic_id,
                color: this.banner.color,
                start_time: this.banner.start_time/1000,
                end_time:this.banner.end_time/1000
            }
            banner_add(params).then(res => {
                if(res) {
                    this.tab = 'table'
                    this.getDetail(this.place_id)
                }
            }).finally( ()=> {
                this.disabled = false
            })
        },

        // 添加轮播图
        handlePut() {
            if(this.image.pic_id == ''){
                return false
            }

            if(this.banner.title == ''){
                return false
            }

            if(this.banner.sort_id === ''){
                return false
            }

            if(this.banner.link == ''){
                return false
            }

            if(this.banner.start_time == ''){
                return false
            }

            if(this.banner.end_time == ''){
                return false
            }

            this.disabled = true
            let params = {
                title: this.banner.title,
                place_id: this.place_id,
                sort_id: this.banner.sort_id,
                link:this.banner.link,
                pic_id: this.image.pic_id,
                color: this.banner.color,
                start_time: this.banner.start_time/1000,
                end_time:this.banner.end_time/1000
            }
            banner_put(this.banner.id, params).then(res => {
                if(res) {
                    this.tab = 'table'
                    this.getDetail(this.place_id)
                }
            }).finally( ()=> {
                this.disabled = false
            })
        },

       // 列表点击修改
       handleGoPut(row) {
           this.image.pic_id = row.pic_id
           this.image.url    = row.pic_url
           this.banner = {
                id: row.id,
                title: row.title,
                sort_id: row.sort_id,
                link: row.link,
                color:row.color,
                start_time: row.start_time*1000,
                end_time:row.end_time*1000
           }
           this.tab = 'edit'
           console.log(this.banner)
       },


       // 更改排序
       handleSort(row) {
           if(row.sort_id == ''){
                return false
            }
            let params = {
                sort_id: row.sort_id,
            }
            banner_put(row.id, params).then(res => {
                if(res) {
                    this.$message({type:"success",message:res.msg})
                }
            })
       },

        // 删除SkU
        handleDel(index, it){
            
            this.$confirm(`此操作将删除  ${it.title}，是否继续?`, '提示', { type: 'warning' }).then(() => {
                banner_del(it.id).then(res => {
                    if(res) {
                        this.$message({type:"success",message:res.msg})
                        this.tableData.splice(index, 1)
                    }
                })
            }).catch(() => {
                          
            });
            
        },

     
    },

    created(){
        this.title = this.$route.query.title
        this.place_id = this.$route.params.id
        this.getDetail(this.place_id)
    },
    activated() {
        this.title = this.$route.query.title
        this.place_id = this.$route.params.id
        this.getDetail(this.place_id)
    }
    
}
</script>
<style lang="less" scoped>
section {
    .input-left {
        height: 40px;
        line-height: 40px;
        min-width:80px ;
    }
    /deep/ .el-tabs__content {
        padding: 30px;
    }
    /deep/  .el-input--mini .el-input__inner  {
        text-align: center;
        width: 60px;
    }
    .suggest-size {
        line-height: 100px;
        color: grey;
        font-size: 0.9em;
    }   
}
</style>

